'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { pageTypes } from '@haaretz/s-consts';
import React from 'react';
const PageTypeContext = /*#__PURE__*/ React.createContext(undefined);
const PageTypeSetter = /*#__PURE__*/ React.createContext(undefined);
export function PageTypeProvider({ children, value: defaultPageType }) {
    const [pageType, setPageType] = React.useState(defaultPageType);
    const pageTypeSetter = React.useCallback((value)=>{
        const validatedPageType = pageTypes.includes(value) ? value : 'Homepage';
        setPageType(validatedPageType);
    }, []);
    return /*#__PURE__*/ _jsx(PageTypeContext, {
        value: pageType,
        children: /*#__PURE__*/ _jsx(PageTypeSetter, {
            value: pageTypeSetter,
            children: children
        })
    });
}
export default function usePageType() {
    const context = React.use(PageTypeContext);
    if (context === undefined) {
        throw new Error('usePageType must be used within a PageTypeProvider');
    }
    return context;
}
export function useSetPageType() {
    const context = React.use(PageTypeSetter);
    if (context === undefined) {
        throw new Error('useSetPageType must be used within a PageTypeProvider');
    }
    return context;
}
export function usePageTypeAtom() {
    return [
        usePageType(),
        useSetPageType()
    ];
}

//# sourceMappingURL=pageTypeAtom.js.map